import { createHelpers } from 'vuex-map-fields'
const axios = require('axios').default
const { getField, updateField } = createHelpers({
    getterType: 'getField',
    mutationType: 'updateField'
})

const getDefaultState = () => {
    return {
        id: null,
        name: null,
        section_type: null,
        section_type_id: null,
        section_type_name: null,
        private_section: false,
        variables: [],
        variable: null,
        error_messages: [],

        _saving: false,
        _loading: false
    }
}

const sections = {

    namespaced: true,
    strict: true,

    state: getDefaultState(),

    getters: {
        getField
    },

    mutations: {
        updateField,

        RESET_STATE (state) {
            Object.assign(state, getDefaultState())
        },

        SET_SECTION (state, payload) {
            state.id = payload.id
            state.name = payload.name
            state.private_section = payload.private_section === 1
            state.section_type_id = payload.section_type_id
            state.section_type = null
            if (payload.section_type_id !== null && payload.section_type_id !== '') {
                state.section_type = {
                    id: payload.section_type_id,
                    name: payload.section_type_name
                }
                state.section_type_name = payload.section_type_name
            }
            state.variables = payload.variables
        },

        SET_SAVING (state, payload) {
            state._saving = payload
        },

        SET_LOADING (state, payload) {
            state._loading = payload
        },

        SET_LOADING_SECTIONS (state, payload) {
            state._loading_sections = payload
        },

        SET_ERROR_MESSAGES (state, payload) {
            state.error_messages = []
            for (const [obj] of Object.values(payload)) {
                state.error_messages.push(obj)
            }
        },
        SET_VARIABLE (state, payload) {
            state.variables.push({ ehr_section_variable_id: payload.response.data.resource.id, id: payload.variable.id, name: payload.variable.name })
        },
        UNSET_VARIABLE (state, payload) {
            state.variables.splice(payload, 1)
        }
    },

    actions: {

        // MISC
        resetState ({ commit }) {
            commit('RESET_STATE')
        },

        pluckResources ({ commit }, excludedIds) {
            commit('SET_LOADING_SECTIONS', true)

            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/ehr/sections/pluck',
                    params: { excluded_ids: [excludedIds] || null }
                }).then(response => {
                    commit('SET_LOADING_SECTIONS', false)
                    resolve(response.data)
                }).catch(error => {
                    commit('SET_LOADING_SECTIONS', false)
                    reject(error)
                })
            })
        },

        fetchResources ({ commit }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/ehr/sections'
                }).then(response => {
                    commit('SET_LOADING_SECTIONS', response.data.data)
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        fetchResource ({ commit }, id) {
            commit('RESET_STATE')

            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/ehr/sections/show/' + id
                }).then(response => {
                    commit('SET_SECTION', response.data)
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        storeResource ({ state, commit }) {
            commit('SET_SAVING', true)
            return new Promise((resolve, reject) => {
                const resource = {
                    id: state.id || null,
                    name: state.name,
                    private_section: state.private_section,
                    section_type_id: state.section_type?.id,
                    section_type: state.section_type,
                    variables: state.variables || []
                }

                axios({
                    method: 'post',
                    url: '/ehr/sections/store',
                    data: resource
                })
                    .then(response => {
                        commit('SET_SAVING', false)
                        resolve(response)
                    })
                    .catch(error => {
                        commit('SET_SAVING', false)
                        commit('SET_ERROR_MESSAGES', error.response.data.errors)
                        reject(error)
                    })
            })
        },

        updateResource ({ state, commit }) {
            commit('SET_SAVING', true)

            return new Promise((resolve, reject) => {
                const resource = {
                    id: state.id || null,
                    name: state.name,
                    variables: state.variables || []
                }

                axios({
                    method: 'patch',
                    url: '/ehr/sections/update/' + state.id,
                    data: resource
                })
                    .then(response => {
                        commit('SET_SAVING', false)
                        resolve(response)
                    })
                    .catch(error => {
                        commit('SET_SAVING', false)
                        commit('SET_ERROR_MESSAGES', error.response.data.errors)
                        reject(error)
                    })
            })
        },

        deleteResource ({ state }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'delete',
                    url: '/ehr/sections/delete/' + state.id
                }).then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        storeVinculation ({ state, commit }) {
            commit('SET_SAVING', true)

            return new Promise((resolve, reject) => {
                const resource = {
                    variable_id: state.variable.id,
                    section_id: state.id
                }
                axios({
                    method: 'post',
                    url: '/ehr/sections/variables/store',
                    data: resource
                })
                    .then(response => {
                        commit('SET_VARIABLE', { variable: state.variable, response: response })
                        commit('SET_SAVING', false)
                        resolve(response)
                    })
                    .catch(error => {
                        commit('SET_SAVING', false)
                        commit('SET_ERROR_MESSAGES', error.response.data.errors)
                        reject(error)
                    })
            })
        },
        deleteVinculation ({ state, commit }, index) {
            commit('SET_LOADING', true)
            return new Promise((resolve, reject) => {
                axios({
                    method: 'delete',
                    url: '/ehr/sections/variables/delete/' + state.variable.ehr_section_variable_id
                }).then(response => {
                    commit('UNSET_VARIABLE', index)
                    commit('SET_LOADING', false)
                    resolve(response.data)
                }).catch(error => {
                    commit('SET_ERROR_MESSAGES', error.response.data.errors)
                    commit('SET_LOADING', false)
                    reject(error)
                })
            })
        }
    }
}

export default sections
